import { observer } from 'mobx-react-lite';

import { Link } from 'react-router-dom';
import { Button, Form, Grid, Header, Segment } from 'semantic-ui-react';

import { Image } from 'semantic-ui-react';

export default observer(function PhysicalAssetIdentifier() {
  //const LabelAutoGeneratedIdentifiers = () => (
  //    <div>
  //        <Label as='a'>
  //            <Image src='barcode.jpg' size='massive' spaced='right' />
  //        </Label>
  //    </div>
  //)

  //export default LabelAutoGeneratedIdentifiers
  //function handleInputChange(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
  //    const { name, value } = event.target;
  //    setActivity({ ...activity, [name]: value })
  //}

  return (
    <Segment
      clearing
      style={{
        marginTop: '6em',
        padding: '10px',
        marginLeft: '1em',
        marginRight: '1em',
        marginBottom: '1em',
      }}
    >
      <Form>
        <Header
          icon="edit"
          size="huge"
          dividing
          as="h1"
          content="Identifier Tags for Physical Asset"
          sub
          color="grey"
        />
        <Header
          icon="tags"
          content="Identifier Tags for Physical Asset "
          sub
          color="red"
        />
        <Segment color="orange">
          <Header />
          <Grid columns={3}>
            <Grid.Row>
              <Grid.Column>
                <Header icon="barcode" content="Barcode" sub color="red" />
                <Header />
                <Image
                  size="medium"
                  src="/assets/createModify/barcode.jpg"
                  centered
                />
                <Header />
                <Form.Button
                  fluid
                  color="teal"
                  pointing="top"
                  icon="barcode"
                  content="Print Barcode"
                  size="huge"
                />
              </Grid.Column>
              <Grid.Column>
                <Header icon="qrcode" content="QRcode" sub color="red" />
                <Header />
                <Image
                  size="medium"
                  src="/assets/createModify/qrcode.jpg"
                  centered
                />
                <Header />
                <Form.Button
                  fluid
                  color="teal"
                  pointing="top"
                  icon="qrcode"
                  content="Print QRcode"
                  size="huge"
                />
              </Grid.Column>
              <Grid.Column>
                <Header icon="rss" content="NFC" sub color="red" />
                <Header />
                <Image
                  size="medium"
                  src="/assets/createModify/nfc.jpg"
                  centered
                />
                <Header />
                <Form.Button
                  fluid
                  color="teal"
                  pointing="top"
                  icon="rss"
                  content="Set NFC"
                  size="huge"
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Form>

      <Header icon="pallet" content="RFid Tags" sub color="red" />
      <Segment color="red">
        <Form>
          <Grid columns={3}>
            <Grid.Row>
              <Grid.Column>
                <Header icon="rss square" content="Rfid" sub color="red" />
                <Header />
                <Image
                  size="medium"
                  src="/assets/createModify/passive_rfid.png"
                  centered
                />
                <Header />
                <Form.Button
                  fluid
                  color="teal"
                  pointing="top"
                  icon="rss square"
                  content="Can RFid"
                  size="huge"
                />
              </Grid.Column>
              <Grid.Column>
                <Header icon="rss square" content="Start" sub color="red" />
                <Header />
                <Image
                  size="medium"
                  src="/assets/createModify/passive_rfid.png"
                  centered
                />
                <Header />
                <Form.Button
                  fluid
                  color="teal"
                  pointing="top"
                  icon="rss square"
                  content="Start RFid"
                  size="huge"
                />
              </Grid.Column>
              <Grid.Column>
                <Header icon="rss square" content="End" sub color="red" />
                <Header />
                <Image
                  size="medium"
                  src="/assets/createModify/passive_rfid.png"
                  centered
                />
                <Header />
                <Form.Button
                  fluid
                  color="teal"
                  pointing="top"
                  icon="rss square"
                  content="End RFid"
                  size="huge"
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Header
                  icon="rss square"
                  content="Active RFid"
                  sub
                  color="red"
                />
                <Header />
                <Image
                  size="medium"
                  src="/assets/createModify/active_rfid.png"
                  centered
                />
                <Header />
                <Form.Button
                  fluid
                  color="teal"
                  pointing="top"
                  icon="rss square"
                  content="Can RFid"
                  size="huge"
                />
              </Grid.Column>
              <Grid.Column>
                <Header
                  icon="rss square"
                  content="Start RFid"
                  sub
                  color="red"
                />
                <Header />
                <Image
                  size="medium"
                  src="/assets/createModify/active_rfid.png"
                  centered
                />
                <Header />
                <Form.Button
                  fluid
                  color="teal"
                  pointing="top"
                  icon="rss square"
                  content="Start RFid"
                  size="huge"
                />
              </Grid.Column>
              <Grid.Column>
                <Header icon="rss square" content="End RFid" sub color="red" />
                <Header />
                <Image
                  size="medium"
                  src="/assets/createModify/active_rfid.png"
                  centered
                />
                <Header />
                <Form.Button
                  fluid
                  color="teal"
                  pointing="top"
                  icon="rss square"
                  content="End RFid"
                  size="huge"
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Segment>

      <Button.Group floated="right">
        <Button as={Link} to="/createActivity">
          Cancel
        </Button>
        <Button.Or />
        <Button
          as={Link}
          to="activities/eebe75e6-045b-4952-8c60-17f7c78f80a8"
          type="submit"
          content="Submit"
          positive
        >
          Save
        </Button>
      </Button.Group>
    </Segment>
  );
});
